module.exports = __webpack_public_path__ + "img/img_dmain4.7f9359bb.jpg";